export const ADMINS_FIELDS = 'resources.admins.fields'
export const ROLES_FIELDS = 'resources.roles.fields'
export const COMMON_FIELDS = 'resources.common.fields'

export const PRODUCTS_TIRE_FIELDS = 'resources.products.tire.fields'
export const PRODUCTS_SHOCK_FIELDS = 'resources.products.shock.fields'
export const PRODUCTS_BRAKE_FIELDS = 'resources.products.brake.fields'
export const PRODUCTS_LUBRICANT_FIELDS = 'resources.products.lubricant.fields'
export const PRODUCTS_BATTERY_FIELDS = 'resources.products.battery.fields'
export const PRODUCTS_OTHER_FIELDS = 'resources.products.other.fields'
export const PRODUCTS_COMMON_FIELDS = 'resources.products.common.fields'
export const PRODUCTS_CSV = 'resources.products.csv'

export const HERO_BANNERS_FIELDS = 'resources.hero_banners.fields'
export const PORTAL_MENUS_FIELDS = 'resources.portal_menus.fields'
export const PARTNER_ICONS_FIELDS = 'resources.partner_icons.fields'
export const CONTACT_US_FIELDS = 'resources.contact_us.fields'
export const CATALOGUES_FIELDS = 'resources.catalogues.fields'
export const PROMOTIONS_FIELDS = 'resources.promotions.fields'
export const SERVICES_FIELDS = 'resources.services.fields'
export const NEWS_FIELDS = 'resources.news.fields'
export const BLOGS_FIELDS = 'resources.blogs.fields'
export const JOB_OPPORTUNITIES_FIELDS = 'resources.job_opportunities.fields'

export const IMPORT_FIELDS = 'resources.import.fields'
export const PRODUCT_BANNERS_FIELDS = 'resources.product_banners.fields'
export const PRODUCT_REVIEWS_FIELDS = 'resources.product_reviews.fields'
export const CSR_FIELDS = 'resources.csr.fields'
